// utils/audio.ts
let unlocked = false;
let diceAudio: HTMLAudioElement | null = null;

export function unlockAudio() {
  if (unlocked) return;
  diceAudio = new Audio('/dice.mp3');
  diceAudio.preload = 'auto';
  unlocked = true;
}

export async function playDiceSound() {
  try {
    if (!unlocked) unlockAudio();
    if (!diceAudio) return;
    diceAudio.currentTime = 0;
    await diceAudio.play();
  } catch {
  }
}
